module.exports = __webpack_public_path__ + "img/global-not_notice.png?820d12d9";